import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {toggleShowAllQuotesCartItemsList, toggleShowMobileQuotes} from "../../actions/shoppingCartFunctions";

const ShoppingCartListSwitcher = (props) => {

  const {quotes, showAllQuotesCartItemsList, toggleShowAllQuotesCartItemsList, toggleShowMobileQuotes} = props;

  if (quotes.length <= 1) {
    return null
  }

  const handleButtonClick = () => {
    toggleShowMobileQuotes(false);
    toggleShowAllQuotesCartItemsList(!showAllQuotesCartItemsList);
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"><FormattedMessage id="header.quoteButton"/></span>
      <button className={"ui-radio ui-radio--small" + (showAllQuotesCartItemsList ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {showAllQuotesCartItemsList} = store.cartState;
  return {
    quotes: store.quotesState.quotes,
    showAllQuotesCartItemsList,
  };
};

const mapDispatchToProps = {
  toggleShowAllQuotesCartItemsList,
  toggleShowMobileQuotes
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartListSwitcher);
